import { RegionType } from './reduxRepositories/region/region.enum';

export const regionConfig = {
  region: RegionType.AU,
  US: 'https://conneqt.hitiq.com/',
  AU: 'https://conneqt.hitiq.com.au/',
};
